import { requests } from '../../../../utils';
import { BRAND_BRIEFING, BRIEFING_LONG_TERM, BRIEFING_URL_MODAL, GROUPS_URL } from '../../../../utils/endpoints';
import { ICreateCampaign } from './dto/ICreateCampaign';
import { ITimeline } from '../../../../model/briefing/step3/ITimeline';
import { IContentCreator } from '../../../../model/briefing/step5/IContentCreator';
import { IStepSeven } from './dto/IStepSeven';
import { IStepFour } from './dto/IStepFour';
import { IBriefingCommentRequest } from './dto/IBriefingCommentRequest';
import { BaseModel } from '../../../../model/shared/BaseModel';
import { iManageMessage } from '../manage/calendar/dto/IManageCalendar';
import { ILongTermCampaign, ILongTermFilter } from './dto/ILongTermCamaign';
import { IAddGroup, ICompanyUserGroup } from '../../../shared/user/dto/ICompanyUserGroup';

export const BriefingService = {
    getBriefingModalData: (id?: any): Promise<ICreateCampaign> => requests.get(`${BRIEFING_URL_MODAL}/${id}`),
    getBriefingStepOne: (id: string) => requests.get(`${BRAND_BRIEFING}/first/${id}`),
    updateStepOne: (id: string, body: any) => requests.put(`${BRAND_BRIEFING}/first/${id}`, body),
    getBriefingByStep: (id: string, step: string) => requests.get(`${BRAND_BRIEFING}/${step}/${id}`),
    updateBriefingByStep: (id: string, body: any, step: string) =>
        requests.put(`${BRAND_BRIEFING}/${step}/${id}`, body),
    updateBriefingStepTwo: (id: string, body: any) =>
        requests.put(`${BRAND_BRIEFING}/second/${id}`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    updateBriefingStepEight: (id: string, body: any) =>
        requests.put(`${BRAND_BRIEFING}/eighth/${id}`, body, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    getBriefingStepFourth: (id?: string): Promise<IStepFour> => requests.get(`${BRAND_BRIEFING}/fourth/${id}`),
    deleteBriefingImageByStep: (extraRoute: string, id?: string) =>
        requests.delete(`${BRAND_BRIEFING}/${extraRoute}/${id}`),
    getBriefingStepThree: (id?: string) => requests.get(`${BRAND_BRIEFING}/third/${id}`),
    updateStepThree: (body: ITimeline, id?: string) => requests.put(`${BRAND_BRIEFING}/third/${id}`, body),
    getBriefingStepFive: (id?: string) => requests.get(`${BRAND_BRIEFING}/fifth/${id}`),
    updateStepFive: (body: IContentCreator, id?: string) => requests.put(`${BRAND_BRIEFING}/fifth/${id}`, body),
    getStepSeven: (id?: string): Promise<IStepSeven> => requests.get(`${BRAND_BRIEFING}/seventh/${id}`),
    getCustomerSuccessComment: (id: string, props: any): Promise<BaseModel<iManageMessage[]>> =>
        requests.get(`${BRAND_BRIEFING}/comment/get/${id}`, props),
    getBriefingComment: (id: string, props: any): Promise<BaseModel<iManageMessage[]>> =>
        requests.get(`${BRAND_BRIEFING}/briefing/comment/get/${id}`, props),
    postCustomerSuccessComment: (body: IBriefingCommentRequest): Promise<iManageMessage[]> =>
        requests.post(`${BRAND_BRIEFING}/comment/send`, body),
    postBriefingComment: (body: IBriefingCommentRequest): Promise<iManageMessage[]> =>
        requests.post(`${BRAND_BRIEFING}/briefing/comment/send`, body),
    getLongTermContracts: (filterParams?: ILongTermFilter): Promise<BaseModel<ILongTermCampaign[]>> =>
        requests.get(`${BRIEFING_LONG_TERM}`, filterParams),
    getCampaignGroups: (campaignId?: string): Promise<ICompanyUserGroup[]> =>
        requests.get(`${GROUPS_URL}/campaign/${campaignId}`),
    addCampaignGroups: (body: IAddGroup, campaignId?: string | number): Promise<ICompanyUserGroup[]> =>
        requests.put(`${GROUPS_URL}/campaigns/${campaignId}`, body),
};
